export default "__VITE_ASSET__DXiFLlU___"